





















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Box extends Vue {
  @Prop({ default: false }) readonly hasHeader!: boolean;

  @Prop({ default: 'container' }) readonly containerClass!: string;
}
